import { render, staticRenderFns } from "./CarouselFuturesCategories.vue?vue&type=template&id=7cf8679e&scoped=true&"
import script from "./CarouselFuturesCategories.vue?vue&type=script&lang=js&"
export * from "./CarouselFuturesCategories.vue?vue&type=script&lang=js&"
import style0 from "./CarouselFuturesCategories.vue?vue&type=style&index=0&id=7cf8679e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf8679e",
  null
  
)

export default component.exports